export const PRICE = {
  GBP: { symbol: "£", base: "600", region: "one-off payment (UK)", label: "£ GBP (UK)" },
  USD: { symbol: "$", base: "800", region: "one-off payment (International)", label: "$ USD (Intl)" },
};

export const FEATURES = [
  "Up to 5 professionally designed pages — you choose how they're used",
  "About Us section",
  "Pricing section",
  "Services section",
  "Contact Us section (phone, email, address)",
  "Portfolio section",
  "Legal & Privacy page",
  "Mobile-friendly design",
  "Basic SEO setup",
  "1 year domain registration included",
  "Fully deployed and live (hosted free via GitHub Pages)",
  "GitHub account set up and handed over with full login details",
  "Tutorial document so you always know how to manage your site",
];

export const SUMMARY_FEATURES = [
  "Up to 5 professionally designed pages",
  "Mobile-friendly design",
  "Basic SEO setup",
  "1 year domain registration included",
  "Fully deployed and live",
];

export const ADDONS = [
  {
    icon: "mail",
    title: "Enquiry Form",
    desc: "Let customers send you enquiries directly through your website",
    benefit: "",
    gbp: "£49",
    usd: "$65",
  },
  {
    icon: "help",
    title: "FAQ Section",
    desc: "Add a frequently asked questions section to help answer common customer queries",
    benefit: "Saves you time answering repetitive calls and messages",
    gbp: "£49",
    usd: "$65",
  },
];
